import Grid from '@mui/material/Unstable_Grid2';

import {
  EntityApiDefinitionCard,
  EntityConsumingComponentsCard,
  EntityProvidingComponentsCard,
} from '@backstage/plugin-api-docs';
import { TableColumn } from '@backstage/core-components';
import {
  ComponentEntity,
  RELATION_PART_OF,
  RELATION_OWNED_BY,
  RELATION_API_PROVIDED_BY,
} from '@backstage/catalog-model';
import { EntityTable } from '@backstage/plugin-catalog-react';
import {
  EntityLayout,
  EntityAboutCard,
} from '@internal/plugin-medidata-catalog-react';

import { entityWarningContent } from './commonContent';

const componentEntityColumns: TableColumn<ComponentEntity>[] = [
  EntityTable.columns.createEntityRefColumn({ defaultKind: 'Component' }),
  EntityTable.columns.createEntityRelationColumn({
    title: 'Product',
    relation: RELATION_PART_OF,
    defaultKind: 'system',
    filter: {
      kind: 'system',
    },
  }),
  EntityTable.columns.createEntityRelationColumn({
    title: 'Team(s)',
    relation: RELATION_OWNED_BY,
    defaultKind: 'group',
  }),
  EntityTable.columns.createSpecTypeColumn(),
  EntityTable.columns.createSpecLifecycleColumn(),
  EntityTable.columns.createMetadataDescriptionColumn(),
];

export const apiPage = (
  <EntityLayout
    parentEntityRelations={[RELATION_API_PROVIDED_BY, RELATION_PART_OF]}
  >
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={1}>
        <Grid md={5}>
          <EntityAboutCard />
        </Grid>
        <Grid md={7}>
          <EntityProvidingComponentsCard columns={componentEntityColumns} />
        </Grid>
        {entityWarningContent}

        <Grid md={12} xs={12}>
          <EntityConsumingComponentsCard columns={componentEntityColumns} />
        </Grid>
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/definition" title="Definition">
      <Grid container spacing={1}>
        <Grid xs={12}>
          <EntityApiDefinitionCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
